import { Routes } from '@angular/router';
import { Login } from './features/auth/login/login';
import { guestGuard } from './core/guards/guest.guard';
import { PlatformSelector } from './features/platform-selector/platform-selector.component';
import { PlatformLayout } from './core/layouts/platform-layout/platform-layout.component';
import { TcLayout } from './core/layouts/tc-layout/tc-layout.component';
import { PlatformGuard } from './core/guards/platform.guard';
import { authGuard } from './core/guards/auth.guard';
import { getPlatformConfigs, APP_PATHS } from './core/constants/platform-config.constants';
import { PlatformType } from './core/models/platform.model';

import { NavItem } from './core/models/platform.model';

import { permissionGuard } from './core/guards/permission.guard';
import { userStatusGuard } from './core/guards/user-status.guard';

const mapNavItemsToRoutes = (navItems: NavItem[]): Routes => {
  return navItems.map((nav) => {
    const children: Routes = nav.children ? mapNavItemsToRoutes(nav.children) : [];

    const data: any = {
      permissions: nav.permissions,
      permissionMatchMode: nav.permissionMatchMode || 'ANY',
    };

    const canActivate = nav.permissions && nav.permissions.length > 0 ? [permissionGuard] : [];

    if (nav.loadComponent || nav.component) {
      if (children.length > 0) {
        // Parent has children: put the component on an empty-path child
        // so named children (e.g. 'add', 'edit/:id') can replace it in the outlet.
        children.unshift({
          path: '',
          loadComponent: nav.loadComponent,
          component: nav.component,
          data,
          canActivate,
        });
        return { path: nav.path, children, data, canActivate };
      }
      return {
        path: nav.path,
        loadComponent: nav.loadComponent,
        component: nav.component,
        data,
        canActivate,
      };
    }

    return { path: nav.path, children, data, canActivate };
  });
};

const generatePlatformRoutes = () => {
  const platformRoutes: Routes = [];

  getPlatformConfigs().forEach((config, type) => {
    const layout = type === PlatformType.TC ? TcLayout : PlatformLayout;

    platformRoutes.push({
      path: config.routePrefix.replace('/', ''),
      component: layout,
      canActivate: [authGuard, userStatusGuard, PlatformGuard],
      canActivateChild: [PlatformGuard],
      data: { platform: type },
      children: [
        ...mapNavItemsToRoutes(config.navItems),
        { path: '', redirectTo: APP_PATHS.DASHBOARD, pathMatch: 'full' },
        { path: '**', redirectTo: APP_PATHS.DASHBOARD },
      ],
    });
  });

  return platformRoutes;
};

export const routes: Routes = [
  {
    path: APP_PATHS.LOGIN,
    component: Login,
    canActivate: [guestGuard],
  },
  {
    path: APP_PATHS.SELECT_PLATFORM,
    component: PlatformSelector,
    canActivate: [authGuard, userStatusGuard, PlatformGuard],
  },
  ...generatePlatformRoutes(),
  {
    path: '',
    redirectTo: APP_PATHS.SELECT_PLATFORM,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: APP_PATHS.SELECT_PLATFORM,
  },
];
